import React, { useEffect, useState } from "react";
import CardLayoutOne from "../../components/cards/CardLayoutOne";
import { t } from "i18next";
import MainButton from "../../components/buttons/MainButton";
import { useNavigate } from "react-router-dom";
const products = [
  {
    id: 23,
    name: "TWIN TREES 2x",
    description:
      "The planet is facing destruction by the minute. Help reverse this damage by planting two trees in your name with every purchase of this NFT.",
    price: "66",
    image:
      "https://gardenof.life/storage/images/bali/JwEp1ikI1riCycdDALml44H8z.png",
    link: "/subscription/purchase",
    is_subscribed: true,
    quantity: 2,
  },
  {
    id: 4,
    name: "TREE NFT 1x",
    description:
      "The world's forests and natural habitats are facing unprecedented destruction. Help safeguard these vital ecosystems today with the TREE NFT.",
    price: "55",
    image:
      "https://gardenof.life/storage/images/brazil/TsRCFyiBHciN6L8wtqKYWoEcm.png",
    link: "/subscription/purchase",
    is_subscribed: true,
    quantity: 1,
  },
  {
    id: 25,
    name: "COMPASSION CARD 1x",
    description:
      "Support vital animal welfare programs with the Compassion Card. Take action today to protect animals in need.",
    price: "55",
    image:
      "https://gardenof.life/assets/images/compassion-card/compassion-card.png",
    link: "/subscription/purchase",
    is_subscribed: true,
    quantity: 1,
  },
  {
    id: 8,
    name: "ENDANGERED WILDLIFE 2x",
    description:
      "Several endangered species worldwide are on the brink of extinction. Take action today to protect them.",
    price: "66",
    image:
      "https://gardenof.life/storage/images/botswana/na48cTEFroTcLryo3wiBmicVC.png",
    link: "/subscription/purchase",
    is_subscribed: true,
    quantity: 2,
  },
];

const Medium = () => {
  const navigate = useNavigate();
  const [selectedProductId, setSelectedProductId] = useState<number | null>(
    () => {
      const savedId = localStorage.getItem("selectedProductId");
      return savedId ? parseInt(savedId, 10) : null;
    }
  );

  const handleSelect = (id: number, isChecked: boolean) => {
    if (isChecked) {
      setSelectedProductId(id);
      localStorage.setItem("selectedProductId", id.toString());
    } else {
      setSelectedProductId(null);
      localStorage.removeItem("selectedProductId");
    }
  };

  const handleClick = () => {
    if (selectedProductId) {
      const selectedProduct = products.find(
        (product) => product.id === selectedProductId
      );
      const subscriptionLinkCode =
        new URL(window.location.href).searchParams.get("code") || "defaultCode";
      localStorage.setItem("selectedProduct", JSON.stringify(selectedProduct));
      localStorage.setItem("subscriptionLinkCode", subscriptionLinkCode);
      navigate("/checkout");
    }
  };
  return (
    <>
      <section className="pb-5 subscription-sec">
        <div className="container">
          <div className="subscription-head-sec text-center">
            <h1 className="mb-3">MID Plan</h1>
            <h6 className="mb-3">Select any one from the below and redeem</h6>
          </div>
          <div className="row mt-5">
            {products.map((item, index) => (
              <CardLayoutOne
                key={index}
                btnText={t("buttons.buyNow")}
                btnFullWidth={""}
                colClass={"col-lg-3 col-md-6"}
                shadow={true}
                title={item.name}
                bgColor={"three"}
                image={item.image}
                titleClass={"f-title-bold"}
                imageClass={"h-200"}
                price={item.price}
                description={item.description}
                is_subscribed={item.is_subscribed}
                id={item.id}
                disabled={
                  selectedProductId !== null && selectedProductId !== item.id
                }
                onSelect={handleSelect}
                isChecked={selectedProductId === item.id}
              />
            ))}
          </div>

          <div className="text-center">
            <MainButton
              onClick={handleClick}
              className={`btn btn-primary-dark ps-lg-5 pe-lg-5 ps-3 pe-3`}
              text="Buy Now"
              withLogo={false}
              disabled={selectedProductId === null}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Medium;
